import { render, staticRenderFns } from "./BottleSizeTable.vue?vue&type=template&id=6c4d7816"
import script from "./BottleSizeTable.vue?vue&type=script&lang=ts"
export * from "./BottleSizeTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports